module.exports = __webpack_public_path__ + "static/img/pet-active.a5f451a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/pet-active.png
// module id = i8o8
// module chunks = 26